import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "wrap-content",
        minHeight: "150px",
        maxHeight: "400px",
        minWidth: "400px",
        width: "400",
        maxWidth: "600px",
        backgroundColor: "white",
        padding: "10px",
    },
    content: {
        display: "flex",
        flexDirection: "column"
    },
    title: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    description: {
        minHeight: "200px",
        padding: "5px 5px 5px 5px"
    },
    reportContainer: {
        display: "none",
        flexDirection: "row",
        marginTop: "10px",
    },
    reportValue: {
        textDecoration: "underline",
        "&:hover": {
            cursor: "pointer"
        },
        marginLeft: "10px"
    },
    button: {
        margin: "15px auto 15px auto",
        padding: "5px 15px 5px 15px",
        color: "white",
        backgroundColor: "rgb(0, 83, 159)",
        "&:hover" : {
            backgroundColor: "rgb(0, 55, 107)",
            color: "white"
        },
        "user-select": "none"
    }

});


// WEBPACK FOOTER //
// ./src/components/dialogs/ReportDialogStyles.ts